<div class="min-h-screen bg-surface">
  <!-- Hero: unified welcome + CLB levels -->
  <section class="hero-section relative overflow-hidden border-b border-slate-200" aria-labelledby="home-hero-title">
    <!-- Background layers -->
    <div class="absolute inset-0 bg-gradient-to-br from-slate-50 via-sky-50/50 to-blue-50/60"></div>
    <div
      class="absolute inset-0 bg-[linear-gradient(135deg,transparent_40%,rgba(59,130,246,0.04)_50%,transparent_60%)]">
    </div>
    <div class="pointer-events-none absolute -left-16 -top-16 h-72 w-72 rounded-full bg-blue-100/40 blur-3xl"
      aria-hidden="true"></div>
    <div class="pointer-events-none absolute -bottom-12 right-10 h-56 w-56 rounded-full bg-sky-100/50 blur-3xl"
      aria-hidden="true"></div>
    <div class="pointer-events-none absolute right-1/4 top-8 h-40 w-40 rounded-full bg-indigo-50/40 blur-2xl"
      aria-hidden="true"></div>

    <div class="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <div class="flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-16">

        <!-- Left: text content -->
        <div class="animate-fade-in-up flex flex-1 flex-col lg:max-w-xl">
          <!-- Logo + headline -->
          <h1 id="home-hero-title"
            class="font-display mb-4 flex flex-wrap items-center gap-2 text-3xl font-bold text-slate-900 sm:text-4xl lg:text-[2.75rem]">
            <span>欢迎来到</span>
            <a routerLink="/"
              class="font-display inline-flex items-center gap-0 text-3xl font-bold tracking-tight sm:text-4xl lg:text-[2.75rem]"
              aria-label="Home">
              <img src="favicon.png" alt="U" class="h-9 w-9 shrink-0 object-contain sm:h-10 sm:w-10" />
              <span class="text-slate-800">p</span>
              <span class="text-blue-600">TCF</span>
            </a>
          </h1>

          <p class="font-display text-xl font-semibold leading-snug text-slate-700 sm:text-2xl lg:text-[1.65rem]">
            你的 TCF Canada 提分引擎
          </p>

          <p class="mt-5 max-w-lg text-base leading-relaxed text-slate-500 sm:text-lg">
            突破写作瓶颈，告别盲目备考。<br class="hidden sm:inline" />
            精准对标 CLB 评分标准，助你早日高分上岸。
          </p>

          <div class="mt-4 inline-flex flex-wrap items-center gap-1 text-xs italic text-slate-500">
            如有任何问题和反馈，请给我们留言
            @if (auth.isAuthenticated()) {
              <button (click)="contactActions.openMessageDialog()"
                class="inline-flex items-center justify-center rounded-md p-1 text-slate-500 transition-colors hover:bg-slate-200 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                aria-label="给我留言"
                title="留言">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </button>
              }
            或者联系微信助手
            <button type="button" (click)="contactActions.toggleWechatQR()"
              class="inline-flex items-center justify-center rounded-md p-1 text-slate-500 transition-colors hover:bg-slate-200 hover:text-[#07C160] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              title="添加微信小助手"
              aria-label="添加微信小助手">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.44-2.687 3.877-1.78 6.465.295.013.582.041.869.041 4.339 0 7.957-2.739 8.868-6.4.078-.246.12-.496.12-.746 0-1.592-.796-3.042-2.104-4.054-1.308-1.012-2.693-1.563-4.493-1.092z"/>
              </svg>
            </button>
          </div>

          <div class="mt-6 flex flex-wrap items-center gap-4">
            @if (userGoal()) {
            <a routerLink="/profile"
              class="group inline-flex items-center gap-2 rounded-full bg-emerald-600 px-6 py-3 text-sm font-semibold text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-emerald-500 hover:shadow-xl active:scale-[0.98] sm:text-base">
              <span>🎯</span>
              <span>你的目标: {{ userGoal() }} 分</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round"
                class="transition-transform duration-300 group-hover:translate-x-1">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            } @else {
            <a routerLink="/profile"
              class="group inline-flex items-center gap-2 rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-blue-500 hover:shadow-xl active:scale-[0.98] sm:text-base">
              <span>🎯</span>
              <span>设定你的目标分数</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round"
                class="transition-transform duration-300 group-hover:translate-x-1">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            }
            <button (click)="scrollToPricing()"
              class="group inline-flex items-center gap-2 rounded-full border-2 border-slate-200 bg-white px-6 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-blue-400 hover:bg-slate-50 hover:text-blue-700 hover:shadow-md active:scale-[0.98] sm:text-base">
              查看订阅计划
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round"
                class="transition-transform duration-300 group-hover:translate-y-0.5">
                <path d="M12 5v14M5 12l7 7 7-7" />
              </svg>
            </button>
          </div>

          
        </div>

        <!-- Right: CLB level staircase -->
        <div class="animate-fade-in-up animate-delay-200 flex-1 lg:max-w-xl">
          <p class="mb-4 text-center text-sm font-semibold tracking-wide text-slate-400 uppercase">CLB 写作 · 口语等级</p>
          <div class="relative">
            <!-- Curved arrow (SVG) - below cards -->
            <svg class="absolute -bottom-2 left-0 right-0 h-8 w-full text-sky-200" viewBox="0 0 400 40" fill="none"
              aria-hidden="true">
              <path d="M0 35 Q100 5 200 15 T400 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <path d="M385 8 L400 5 L390 15 Z" fill="currentColor" />
            </svg>

            <div class="flex items-end justify-between gap-2 sm:gap-3">
              @for (card of clbCards; track card.level; let i = $index) {
              <div
                class="flex flex-1 flex-col rounded-xl px-3 py-3 shadow-card transition-all duration-300 hover:-translate-y-0.5 hover:shadow-card-hover"
                [style.background]="card.color" [style.min-height]="card.minHeight">
                <span class="mb-2 flex justify-center">
                  <span
                    class="rounded-full border border-slate-200 bg-white px-2 py-0.5 text-[10px] font-semibold text-slate-700 shadow-sm">
                    {{ card.cefr }}
                  </span>
                </span>
                <div class="flex flex-1 flex-col justify-center text-center">
                  <p class="text-sm font-bold sm:text-base" [class.text-slate-800]="!card.textLight"
                    [class.text-white]="card.textLight">
                    {{ card.level }}
                  </p>
                  <p class="mt-0.5 text-[10px] sm:text-xs" [class.text-slate-700]="!card.textLight"
                    [class.text-white]="card.textLight" [class.text-white\/95]="card.textLight">
                    Score: {{ card.score }}
                  </p>
                </div>
              </div>
              }
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- Core Feature Showcase: 模拟考试界面 -->
  <section class="exam-showcase relative overflow-hidden border-b border-slate-200"
    aria-labelledby="core-features-title">
    <!-- Background decorations -->
    <div class="absolute inset-0 bg-gradient-to-br from-slate-100 via-sky-50/60 to-blue-100/50"></div>
    <div class="pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full bg-blue-200/30 blur-3xl"
      aria-hidden="true"></div>
    <div class="pointer-events-none absolute -bottom-16 -right-16 h-64 w-64 rounded-full bg-sky-200/40 blur-3xl"
      aria-hidden="true"></div>
    <div class="pointer-events-none absolute right-1/3 top-1/4 h-48 w-48 rounded-full bg-indigo-100/30 blur-2xl"
      aria-hidden="true"></div>

    <div class="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <div class="flex flex-col items-center gap-12 lg:flex-row lg:items-center lg:gap-16">

        <!-- Left: Text content -->
        <div class="animate-fade-in-up flex-1 lg:max-w-lg">
          <span
            class="mb-4 inline-block rounded-full bg-blue-600/10 px-4 py-1.5 text-sm font-semibold tracking-wide text-blue-700">
            核心体验
          </span>

          <h2 id="core-features-title"
            class="font-display mt-2 text-3xl font-bold leading-tight tracking-tight text-slate-900 sm:text-4xl lg:text-[2.75rem]">
            全真模拟机考环境
          </h2>

          <p class="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
            提前适应 TCF Canada 机考界面的每一个细节，告别考场慌乱。<br />
            禁用拼写检查与复制粘贴，支持自主统筹多项任务时间，为你打造最极致的沉浸式备考体验。
          </p>

          <!-- Feature bullets -->
          <ul class="mt-8 space-y-4">
            <li class="flex items-center gap-3">
              <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-card">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1e40af" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </span>
              <span class="text-sm font-medium text-slate-800 sm:text-base">精准字数统计与自主时间分配</span>
            </li>
            <li class="flex items-center gap-3">
              <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-card">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1e40af" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
              </span>
              <span class="text-sm font-medium text-slate-800 sm:text-base">硬核限制：无拼写检查、禁复制粘贴</span>
            </li>
            <li class="flex items-center gap-3">
              <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-card">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1e40af" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="M6 8h4M14 8h4M8 12h8M10 16h4" />
                </svg>
              </span>
              <span class="text-sm font-medium text-slate-800 sm:text-base">官方同款法语输入键盘</span>
            </li>
          </ul>

          <!-- CTA button -->
          <div class="mt-10">
            <a routerLink="/writing"
              class="group inline-flex items-center gap-2 rounded-full bg-emerald-600 px-7 py-3.5 text-base font-semibold text-white shadow-lg transition-all duration-300 hover:bg-emerald-500 hover:shadow-xl hover:-translate-y-0.5 active:scale-[0.98]">
              开始全真模考
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round"
                class="transition-transform duration-300 group-hover:translate-x-1">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>

        <!-- Right: Practice screen mockup -->
        <div class="animate-fade-in-up animate-delay-200 flex flex-1 justify-center lg:justify-end">
          <div class="screen-mockup">
            <img src="practice_screen.png" alt="TCF Canada 模拟考试界面 — 展示计时器、法语键盘、写作区域" class="screen-mockup-img"
              loading="lazy" />
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- AI Grading Showcase: AI 批改 -->
  <section class="ai-grading-section relative overflow-hidden border-b border-slate-200"
    aria-labelledby="ai-grading-title">
    <!-- Background -->
    <div class="absolute inset-0 bg-gradient-to-b from-white via-emerald-50/30 to-teal-50/40"></div>
    <div class="pointer-events-none absolute -right-32 top-20 h-72 w-72 rounded-full bg-teal-100/30 blur-3xl"
      aria-hidden="true"></div>
    <div class="pointer-events-none absolute -left-20 bottom-10 h-56 w-56 rounded-full bg-emerald-100/25 blur-3xl"
      aria-hidden="true"></div>

    <div class="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <!-- Section header -->
      <div class="mb-12 text-center">
        <span
          class="mb-4 inline-block rounded-full bg-teal-600/10 px-4 py-1.5 text-sm font-semibold tracking-wide text-teal-700">
          智能批改
        </span>
        <h2 id="ai-grading-title"
          class="font-display mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          AI 深度批改，全面提升写作能力
        </h2>
        <p class="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
          不只是分数，更是一份详尽的写作诊断报告。从语法到句型，从词汇到逻辑，逐项精准分析。
        </p>
      </div>

      <!-- Bento grid -->
      <div class="bento-grid">

        <!-- Card 1: AI 批改 — Full width hero -->
        <div class="bento-card bento-card-hero group">
          <div class="bento-card-label">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            <span>AI 批改</span>
            <span class="bento-card-badge">核心功能</span>
          </div>
          <p class="bento-card-desc">原文与 AI 修改版本对照，清晰标注每一处改进，附带评分与任务完成度分析。</p>
          <div class="bento-card-img-wrap">
            <img src="g1_AI 批改.png" alt="AI 批改 — 原文与修改版对照" class="bento-card-img" loading="lazy" />
          </div>
        </div>

        <!-- Card 2: 高分句型分析 — Large left -->
        <div class="bento-card bento-card-wide group">
          <div class="bento-card-label bento-label-amber">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polygon
                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            <span>高分句型分析</span>
          </div>
          <p class="bento-card-desc">识别已掌握的高级句型，并提供精准升级建议，助你突破瓶颈。</p>
          <div class="bento-card-img-wrap">
            <img src="g2_高分句型分析.png" alt="高分句型分析 — 句型识别与升级建议" class="bento-card-img" loading="lazy" />
          </div>
        </div>

        <!-- Card 3: 语法纠正 — Large right -->
        <div class="bento-card bento-card-wide group">
          <div class="bento-card-label bento-label-rose">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span>语法纠正</span>
          </div>
          <p class="bento-card-desc">逐句分析语法错误，提供自然、地道的法语表达替换方案。</p>
          <div class="bento-card-img-wrap">
            <img src="g3_语法纠正.png" alt="语法纠正 — 逐句语法分析" class="bento-card-img" loading="lazy" />
          </div>
        </div>

        <!-- Card 4: 词汇提升 — Small left -->
        <div class="bento-card bento-card-half group">
          <div class="bento-card-label bento-label-violet">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
            </svg>
            <span>词汇提升</span>
          </div>
          <p class="bento-card-desc">精准标注可优化词汇，推荐更高级的表达。</p>
          <div class="bento-card-img-wrap">
            <img src="g4_词汇提升.png" alt="词汇提升 — 词汇优化建议" class="bento-card-img" loading="lazy" />
          </div>
        </div>

        <!-- Card 5: 逻辑连接词 — Small right -->
        <div class="bento-card bento-card-half group">
          <div class="bento-card-label bento-label-emerald">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="8" y1="6" x2="21" y2="6" />
              <line x1="8" y1="12" x2="21" y2="12" />
              <line x1="8" y1="18" x2="21" y2="18" />
              <line x1="3" y1="6" x2="3.01" y2="6" />
              <line x1="3" y1="12" x2="3.01" y2="12" />
              <line x1="3" y1="18" x2="3.01" y2="18" />
            </svg>
            <span>逻辑连接词</span>
          </div>
          <p class="bento-card-desc">分析已使用和建议补充的逻辑连接词，提升文章连贯性。</p>
          <div class="bento-card-img-wrap">
            <img src="g5_逻辑连接词.png" alt="逻辑连接词 — 连接词分析与建议" class="bento-card-img" loading="lazy" />
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- Subscription Plan Showcase -->
  <section class="pricing-section relative overflow-hidden bg-white border-b border-slate-200 py-16 sm:py-20 lg:py-24"
    aria-labelledby="pricing-title">
    <div class="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

      <div class="mb-14 text-center">
        <h2 id="pricing-title" class="font-display text-3xl font-bold tracking-tight text-slate-800 sm:text-4xl">
          选择适合您的计划
        </h2>
      </div>

      <div class="mx-auto grid max-w-md grid-cols-1 gap-8 lg:max-w-6xl lg:grid-cols-3 lg:gap-8 xl:gap-10">

        <!-- Tier 1: Free Trial -->
        <div
          class="flex flex-col rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:shadow-md hover:border-slate-300">
          <h3 class="text-[1.15rem] font-bold text-slate-900">Tier 1: 免费体验</h3>
          <div class="mt-6 flex items-baseline gap-1">
            <span class="text-[2.5rem] font-bold tracking-tight text-slate-900">¥0</span>
            <span class="text-xl font-bold text-slate-900">/ 永久</span>
          </div>

          <ul class="mt-8 flex-1 space-y-4 text-[0.95rem] font-medium text-slate-700">
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">全真机考界面体验</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">免费 3 次 AI 深度批改</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">基础得分预估</span>
            </li>
            <li class="flex items-center gap-3 text-slate-400">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path
                  d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
              <span class="text-slate-500">高级语法与词汇纠正</span>
            </li>
            <li class="flex items-center gap-3 text-slate-400">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path
                  d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
              <span class="text-slate-500">专属写作题库</span>
            </li>
          </ul>

          <a routerLink="/writing"
            class="mt-8 block w-full rounded-md border border-slate-300 bg-white py-3 text-center text-[1rem] font-medium tracking-wide text-slate-700 transition-colors hover:bg-slate-50">
            免费开始
          </a>
        </div>

        <!-- Tier 2: 1-Month Sprint -->
        <div
          class="flex flex-col rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:shadow-md hover:border-slate-300">
          <h3 class="text-[1.15rem] font-bold text-slate-900">Tier 2: 单月冲刺</h3>
          <p class="mt-3 text-[0.95rem] leading-relaxed text-slate-800">适合考前最后突击</p>
          <div class="mt-6 flex items-baseline gap-1">
            <span class="text-[2.5rem] font-bold tracking-tight text-slate-900">¥50</span>
            <span class="text-xl font-bold text-slate-900">/ 1个月</span>
          </div>
          <ul class="mt-5 flex-1 space-y-4 text-[0.95rem] font-medium text-slate-700">
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">包含免费版所有功能</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">不限次 AI 深度批改</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">完整语法、词汇、逻辑连词分析</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">答题历史与水平追踪</span>
            </li>
          </ul>

          <a routerLink="/pricing"
            class="mt-8 block w-full rounded-md bg-[#1e293b] py-3 text-center text-[1rem] font-medium tracking-wide text-white transition-colors hover:bg-slate-900">
            立即订阅
          </a>
        </div>

        <!-- Tier 3: 3-Month Mastery -->
        <div
          class="relative flex flex-col rounded-2xl border-2 border-[#268367] bg-[#f2fbf7] p-8 shadow-md transition-all duration-300 hover:shadow-lg">
          <div
            class="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-[#d0f6e7] px-4 py-1 text-sm font-bold text-[#1f6652] shadow-sm flex items-center gap-1 border border-[#d0f6e7]">
            💎 性价比之选
          </div>
          <h3 class="mt-2 text-[1.15rem] font-bold text-[#268367] leading-snug">Tier 3: 深度备考 — 👑 核心推荐</h3>

          <div class="mt-6 flex flex-col gap-1">
            <div class="flex items-baseline gap-1">
              <span class="text-[2.5rem] font-bold tracking-tight text-[#268367]">¥100</span>
              <span class="text-xl font-bold text-[#268367]">/ 3个月</span>
              <span class="ml-1 text-sm font-semibold text-slate-500 line-through decoration-slate-400">¥150</span>
            </div>
            <div class="mt-1 w-max rounded-sm bg-[#d0f6e7] px-2 py-0.5 text-[0.85rem] font-bold text-[#1f6652]">
              ¥1.1/天
            </div>
          </div>

          <ul class="mt-6 flex-1 space-y-4 text-[0.95rem] font-medium text-slate-700">
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">包含单月版所有功能</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">充足时间，从容备考</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">优先体验后续更新功能</span>
            </li>
            <li class="flex items-center gap-3 text-emerald-600">
              <svg class="h-5 w-5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd" />
              </svg>
              <span class="text-slate-800">(Optional) 赠送高分写作模板</span>
            </li>
          </ul>

          <a routerLink="/pricing"
            class="mt-8 block w-full rounded-md bg-[#268367] py-3 text-center text-[1rem] font-medium tracking-wide text-white transition-colors hover:bg-[#1a5b48] shadow-sm">
            立即订阅
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Back to Top Button -->
  @if (showBackToTop()) {
  <button (click)="scrollToTop()"
    class="fixed bottom-8 right-8 z-50 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-blue-600 text-white shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-blue-500 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 animate-fade-in-up"
    aria-label="回到顶部">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
  </button>
  }
</div>